/**
 * @generated SignedSource<<35a31ded615a25bc7817332b6e096304>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AssistantMode = "aiStory" | "assistant" | "cardDetail" | "letsPractise" | "listenVocab" | "speaking" | "%future added value";
export type ChatMessageOwnerType = "assistant" | "user" | "%future added value";
export type ChatMessageInputType = {
  id?: string | null;
  owner: ChatMessageOwnerType;
  text: string;
};
export type AssistantAddChatMessagesMutation$variables = {
  chatId?: string | null;
  chatMessages: ReadonlyArray<ChatMessageInputType>;
  deckId: string;
  mode: AssistantMode;
};
export type AssistantAddChatMessagesMutation$data = {
  readonly addChatMessages: {
    readonly chat: {
      readonly chatMessages: ReadonlyArray<{
        readonly analysis: string | null;
        readonly id: string;
        readonly owner: ChatMessageOwnerType;
        readonly text: string;
        readonly translation: string | null;
      }>;
      readonly id: string;
    };
    readonly viewer: {
      readonly id: string;
    };
  };
};
export type AssistantAddChatMessagesMutation = {
  response: AssistantAddChatMessagesMutation$data;
  variables: AssistantAddChatMessagesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chatId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chatMessages"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deckId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mode"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "chatId",
        "variableName": "chatId"
      },
      {
        "kind": "Variable",
        "name": "chatMessages",
        "variableName": "chatMessages"
      },
      {
        "kind": "Variable",
        "name": "deckId",
        "variableName": "deckId"
      },
      {
        "kind": "Variable",
        "name": "mode",
        "variableName": "mode"
      }
    ],
    "concreteType": "ChatResponseType",
    "kind": "LinkedField",
    "name": "addChatMessages",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ChatType",
        "kind": "LinkedField",
        "name": "chat",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatMessageType",
            "kind": "LinkedField",
            "name": "chatMessages",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "translation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "analysis",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "owner",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssistantAddChatMessagesMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssistantAddChatMessagesMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "ce8059223b7394efa26d66d6168247d1",
    "id": null,
    "metadata": {},
    "name": "AssistantAddChatMessagesMutation",
    "operationKind": "mutation",
    "text": "mutation AssistantAddChatMessagesMutation(\n  $chatMessages: [ChatMessageInputType!]!\n  $deckId: String!\n  $chatId: String\n  $mode: AssistantMode!\n) {\n  addChatMessages(chatMessages: $chatMessages, deckId: $deckId, chatId: $chatId, mode: $mode) {\n    chat {\n      id\n      chatMessages {\n        id\n        text\n        translation\n        analysis\n        owner\n      }\n    }\n    viewer {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e33aae762f03d07fa192f84bf12fc487";

export default node;
